import Vue from 'vue';
import Vuex from 'vuex';
import Xml2js from 'xml2js';
import axios from 'axios';
import VueAxios from 'vue-axios';
import jwtdecode from 'jwt-decode';

Vue.use(VueAxios, axios);
Vue.use(Vuex);

// const api = 'http://localhost:4000/';
//const api = "https://regionalkaufen.smd-test.at/api/";
const api = 'https://regionalkaufen.kleinezeitung.at/api/';

interface RssResult {
  rss: any;
}

interface Unternehmen {
  branche: string;
  id: number;
}

interface FilterRequest {
  filter?: FilterRequestFilter;
  fulltext?: string;
}

interface FilterRequestFilter {
  branche?: string;
  bundesland?: string;
  bezirk?: string;
}

interface DataValue {
  id: number;
  name: string;
  bezirke?: Array<DataValue>;
  count?: number;
}

const set: Function = (key: any) => (state: any, val: any) => {
  state[key] = val;
};

const increment: Function = (key: any) => (state: any) => {
  state[key]++;
};

const decrement: Function = (key: any) => (state: any) => {
  state[key]--;
};

export default new Vuex.Store({
  state: {
    token: localStorage.getItem('token') || false,
    tokenexpire: localStorage.getItem('tokenexpire') || false,
    loading: 0,
    fulltext: '',
    ajaxbounce: null,
    showLogin: false,
    loginError: false,
    newsitems: [],
    branche: 0,
    bundesland: 0,
    bezirk: 0,
    order: 0,
    imagedir: api,
    error: '',
    branchen: [],
    bundeslander: [],
    unternehmen: [],
    exportdata: [],
    users: [],
    messages: [],
    dynamicFilters: {
      muttertag: false,
      gesichtsmasken: false,
      osterjause: false,
      ostergeschenke: false,
    },
    presenceFilters: {
      aktionen: false,
    },
  },
  mutations: {
    startLoading: increment('loading'),
    finishLoading: decrement('loading'),
    setNewsitems: set('newsitems'),
    setBranche: set('branche'),
    setBundesland: set('bundesland'),
    setBezirk: set('bezirk'),
    setUnternehmen: set('unternehmen'),
    setFulltext: set('fulltext'),
    setError: set('error'),
    setToken: set('token'),
    setTokenExpire: set('tokenexpire'),
    setShowLogin: set('showLogin'),
    setLoginError: set('loginError'),
    setBranchen: set('branchen'),
    setBundeslander: set('bundeslander'),
    setUsers: set('users'),
    setMessages: set('messages'),
    setDynamicFilters: set('dynamicFilters'),
    setPresenceFilters: set('presenceFilters'),
    setOrder: set('order'),
    setExport: set('exportdata'),
  },
  actions: {
    API(context, { url, data, headers, method }) {
      const options = { headers: {} };
      if (context.state.token) {
        options.headers['Authorization'] = `Token ${context.state.token}`;
      }

      if (headers) {
        for (let i = 0; i < Object.keys(headers).length; i++) {
          const key = Object.keys(headers)[i];
          options.headers[key] = headers[key];
        }
      }
      switch (method) {
        case 'get':
          return axios.get(api + url, options);
          break;
        case 'delete':
          return axios.delete(api + url, options);
          break;
        case 'post':
          return axios.post(api + url, data, options);
          break;
        case 'put':
          return axios.put(api + url, data, options);
          break;
        case 'patch':
          return axios.patch(api + url, data, options);
          break;
      }
    },
    addMessage(context, { message, type }) {
      const msg = context.state.messages;
      const key = context.state.messages.length;
      msg.push({ message, type, key: key });

      setTimeout(function() {
        context.commit(
          'setMessages',
          context.state.messages.filter((item) => item.key != key)
        );
      }, 3000);
      context.commit('setMessages', msg);
    },
    toggleLogin(context) {
      context.commit('setShowLogin', !context.state.showLogin);
    },
    removeBranche(context, id: number) {
      context.commit(
        'setBranchen',
        context.state.branchen.filter((item) => item.id != id)
      );
    },
    addBranche(context, name: string) {
      context.state.branchen.push({ id: 123, name: name, count: 0 });
      //context.commit('setBranchen', );
    },
    upload(context, { id, name, file }) {
      const data = new FormData();
      data.append(name, file);
      return context.dispatch('API', {
        method: 'post',
        url: `upload/${id}`,
        data,
        headers: { 'Content-Type': 'multipart/form-data' },
      });
    },
    deleteImage(context, { userid, id, name }) {
      //console.log(userid, id, name);
      //return null;
      return context.dispatch('API', { method: 'put', url: `unternehmen/${id}`, data: { userid, name } });
    },
    createUser(context, { user, unternehmen }) {
      return context.dispatch('API', { method: 'put', url: 'user/create', data: { user, unternehmen } });
    },
    createUnternehmen(context, unternehmen) {
      return context.dispatch('API', { method: 'put', url: 'unternehmen/', data: unternehmen });
    },
    saveUser(context, user) {
      return context.dispatch('API', { method: 'patch', url: 'admin/users', data: user });
    },
    savePasswordAdmin(context, { id, newpw }) {
      return context.dispatch('API', { method: 'patch', url: 'admin/setpassword', data: { id, newpw } });
    },
    saveUnternehmen(context, unternehmen) {
      //console.log(unternehmen);
      return context.dispatch('API', { method: 'patch', url: `unternehmen/${unternehmen.id}`, data: unternehmen });
    },
    deleteUnternehmen(context, id) {
      return context.dispatch('API', { method: 'delete', url: `unternehmen/${id}` });
    },
    savePassword(context, { current, newpw }) {
      return context.dispatch('API', { method: 'post', url: 'user/setpassword', data: { current, newpw } });
    },
    logout(context) {
      localStorage.removeItem('token');
      localStorage.removeItem('tokenexpire');
      context.commit('setToken', false);
      context.commit('setTokenExpire', false);
    },
    loadUserData(context, id) {
      return context.dispatch('API', { method: 'post', url: 'admin/users', data: { id } });
    },
    getUsers(context) {
      context.dispatch('API', { method: 'get', url: 'admin/users' }).then((response: any) => {
        if (response.data.status != 403) {
          context.commit('setUsers', response.data.message);
        }
      });
    },
    setToken(context, token) {
      const exp = jwtdecode(token).exp * 1000;
      context.commit('setToken', token);
      localStorage.setItem('token', token);
      localStorage.setItem('tokenexpire', exp);
      context.commit('setTokenExpire', exp);
    },
    login(context, { user, password }) {
      return context
        .dispatch('API', { method: 'post', url: 'user/login', data: { user, password } })
        .then((response: any) => {
          context.dispatch('setToken', response.data.message);
          context.commit('setShowLogin', false);
        })
        .catch((err) => {
          context.dispatch('addMessage', { message: 'Falsche Email-Adresse oder Passwort', type: 'error' });
        });
    },
    resetpassword(context, user) {
      return context.dispatch('API', { method: 'post', url: 'user/resetpassword', data: { email: user } });
    },
    refreshToken(context) {
      const diff = context.state.tokenexpire - new Date().getTime();
      if (diff < 0) {
        // Token expired
        context.dispatch('logout');
      } else if (diff < (12 * 60 * 60 * 1000) / 2) {
        // 12h / 2 in ms.. so refresh the token every 6 hrs
        context.dispatch('API', { method: 'post', url: 'user/refresh' }).then((response: any) => {
          if (response.data.status == 403) {
            // Got no token... login error?
            context.dispatch('logout');
          } else {
            context.dispatch('setToken', response.data.message);
          }
        });
      }
    },
    loadMeta(context) {
      context.commit('startLoading');
      return context
        .dispatch('API', { method: 'get', url: 'meta' })
        .then((response: any) => {
          context.commit('setBundeslander', response.data.message);
          context.commit('finishLoading');
        })
        .catch((err: Error) => context.commit('setError', err));
    },
    loadUnternehmen(context) {
      context.commit('startLoading');
      const data: FilterRequest = {};
      if (context.state.branche != 0) {
        if (!data.filter) data.filter = {};
        data.filter.branche = context.state.branche;
      }
      if (context.state.bundesland != 0) {
        if (!data.filter) data.filter = {};
        data.filter.bundesland = context.state.bundesland;
      }
      if (context.state.bezirk != 0) {
        if (!data.filter) data.filter = {};
        data.filter.bezirk = context.state.bezirk;
      }

      if (context.state.fulltext != '') {
        data.fulltext = context.state.fulltext;
      }

      Object.keys(context.state.dynamicFilters).forEach((key) => {
        if (context.state.dynamicFilters[key]) {
          if (!data.filter) data.filter = {};
          data.filter[key] = 1;
        }
      });

      Object.keys(context.state.presenceFilters).forEach((key) => {
        if (context.state.presenceFilters[key]) {
          if (!data.presence) data.presence = [];
          data.presence.push(key);
        }
      });

      if (Object.keys(data).length > 0) {
        return context
          .dispatch('API', { method: 'post', url: 'unternehmen', data })
          .then((response: any) => {
            switch (context.state.order) {
              case 1: // Alphabethisch
                response.data.message.sort((a, b) => (a.firma > b.firma ? 1 : -1));
                break;
              default:
                response.data.message.shuffle();
                break;
            }
            context.commit('setUnternehmen', response.data.message);
            context.commit('finishLoading');
          })
          .catch((err: Error) => context.commit('setError', err));
      } else {
        return context
          .dispatch('API', { method: 'get', url: 'unternehmen' })
          .then((response: any) => {
            switch (context.state.order) {
              case 1: // Alphabethisch
                response.data.message.sort((a, b) => (a.firma > b.firma ? 1 : -1));
                break;
              default:
                response.data.message.shuffle();
                break;
            }
            context.commit('setUnternehmen', response.data.message);
            context.commit('finishLoading');
          })
          .catch((err: Error) => context.commit('setError', err));
      }
    },
    loadExport(context) {
      context.commit('startLoading');
      return context
        .dispatch('API', { method: 'get', url: 'admin/export' })
        .then((response: any) => {
          context.commit('setExport', response.data.message);
          context.commit('finishLoading');
        })
        .catch((err: Error) => context.commit('setError', err));
    },
    loadUnternehmenById(context, id) {
      return context.dispatch('API', { method: 'get', url: 'unternehmen/' + id });
    },
    loadUnternehmenFromCurrentUser(context) {
      return context.dispatch('loadUnternehmenFromUser', jwtdecode(context.state.token.toString()).userid);
    },
    loadUnternehmenFromUser(context, id) {
      return context.dispatch('API', { method: 'post', url: 'user/unternehmen', data: { userid: id } });
    },
    loadBranchen(context) {
      return context
        .dispatch('API', { method: 'get', url: 'branchen' })
        .then((response: any) => {
          context.commit('setBranchen', response.data.message);
        })
        .catch((err: Error) => context.commit('setError', err));
    },
    loadUsers(context) {
      return context
        .dispatch('API', { method: 'get', url: 'admin/users' })
        .then((response: any) => {
          context.commit('setUsers', response.data.message);
        })
        .catch((err: Error) => context.commit('setError', err));
    },
    setDynamicFilter(context, data: object) {
      const filters = context.state.dynamicFilters;
      filters[data.name] = data.value;
      context.commit('setDynamicFilters', filters);
      context.dispatch('loadUnternehmen');
    },
    setPresenceFilters(context, data: object) {
      const filters = context.state.presenceFilters;
      filters[data.name] = data.value;
      context.commit('setPresenceFilters', filters);
      context.dispatch('loadUnternehmen');
    },
    setOrder(context, order: number) {
      context.commit('setOrder', order);
      context.dispatch('loadUnternehmen');
    },
    clearFilters(context) {
      context.commit('setFulltext', '');
      context.commit('setBranche', 0);
      context.commit('setBundesland', 0);
      context.commit('setBezirk', 0);
    },
    setFulltext(context, data: string) {
      context.commit('setFulltext', data);
      context.dispatch('loadUnternehmen');
    },
    setBranche(context, data: DataValue) {
      context.commit('setBranche', data);
      context.dispatch('loadUnternehmen');
    },
    setBundesland(context, data: DataValue) {
      context.commit('setBundesland', data);
      context.commit('setBezirk', 0);
      context.dispatch('loadUnternehmen');
    },
    setBezirk(context, data: DataValue) {
      context.commit('setBezirk', data);
      context.dispatch('loadUnternehmen');
    },
    loadRSS(context) {
      context.commit('startLoading');

      return axios
        .get('https://www.kleinezeitung.at/rss/wirtschaft')
        .then((response: any) => {
          const items: Array<object> = [];
          Xml2js.parseString(response.data, function(err: Error, result: RssResult) {
            context.commit('finishLoading');
            let i = 0;
            Object.keys(result.rss.channel[0].item).forEach(function(key) {
              i++;

              if (i > 10) {
                return;
              }
              const item = result.rss.channel[0].item[key];
              if (item.enclosure && item.link && item.title) {
                items.push({
                  id: key,
                  image: item.enclosure[0].$.url,
                  url: item.link,
                  //headline: item.category[0],
                  title: item.title[0],
                });
              }
            });

            context.commit('setNewsitems', items);
          });
        })
        .catch((err: Error) => context.commit('setError', err));
    },
    filterHashes(context, hashes) {
      hashes.forEach((hash) => {
        hash = decodeURI(hash)
          .substring(1)
          .replace('&', ' & ');

        if (hash.toLowerCase() == 'haushalt') {
          hash = 'haushalt & elektronik';
        }

        // if(hash.toLowerCase() == "muttertag"){
        //   context.dispatch('setDynamicFilter', {name: "muttertag", value: true});
        // }
        //
        // if(hash.toLowerCase() == "gesichtsmasken"){
        //   context.dispatch('setDynamicFilter', {name: "gesichtsmasken", value: true});
        // }
        context.state.branchen.forEach(function(item) {
          if (item.name.toLowerCase() == hash) {
            context.commit('setBranche', item.id);
            //context.dispatch('setBranche', );
          }
        });

        context.state.bundeslander.forEach(function(bundesland) {
          //const bundesland = context.state.bundeslander[findbundesland];

          if (bundesland.name.toLowerCase() == hash.toLowerCase()) {
            context.commit('setBundesland', bundesland.id);
          }

          bundesland.bezirke.forEach((bezirk) => {
            if (bezirk.name.toLowerCase() == hash.toLowerCase()) {
              context.commit('setBundesland', bundesland.id);
              context.commit('setBezirk', bezirk.id);
            }
          });
        });
      });

      //context.dispatch('loadUnternehmen');

      //  console.log(hashes);
    },
  },
  getters: {
    isAdmin: (state: any) => {
      if (state.token) {
        return jwtdecode(state.token.toString()).role == 'admin';
      }
      return false;
    },
    getUserById: (state: any) => {
      (id: number) => {
        if (state.users.length <= 0) {
          return state.users.find((user) => user.id == user);
        } else {
          return state.users.find((user) => user.id == user);
        }
      };
    },
    loggedIn: (state: any) => state.token != false,
    allBranchen: (state: any) => state.branchen,
    allBundeslaender: (state: any) => state.bundeslander,
    getBranche: (state: any) => (id: number) => state.branchen.find((item: DataValue) => item.id == id),
    getBundesland: (state: any) => (id: number) => state.bundeslander.find((item: DataValue) => item.id == id),
    getBezirk: (state: any) => (bundeslandId: number, bezirkId: number) => {
      let erg = {};
      state.bundeslander.forEach((bundesland: DataValue) => {
        if (bundesland.id == bundeslandId) {
          bundesland.bezirke.forEach((bezirk) => {
            if (bezirk.id == bezirkId) {
              erg = bezirk;
            }
          });
        }
      });
      return erg;
    },
    getBezirkeForBundesland: (state: any) => (id: number) => {
      const erg = [];
      state.bundeslander.forEach((bundesland: DataValue) => {
        if (bundesland.id == id) {
          bundesland.bezirke.forEach((bezirk) => {
            erg.push(bezirk);
          });
        }
      });
      return erg;
    },
    //unternehmenById: (state: any) => (id: number) => state.unternehmen.find((item: Unternehmen) => item.id == id)
    // TODO: UPDATE TO NOT ONLY FIND UNTERNEHMEN THAT HAVE BEEN FILTERED!!!!!
  },
});
